"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.TagsLabel = exports.TagsWrapper = exports.CardArticleTag = exports.CardArticleCopy = exports.CardArticleContentInner = exports.CardArticleLabel = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Typography = require("../../Typography");

var CardArticleLabel = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var _ref$theme = _ref.theme,
      cards = _ref$theme.cards,
      colors = _ref$theme.colors,
      space = _ref$theme.space;
  return {
    marginTop: space.medium,
    marginBottom: space.small,
    p: {
      color: colors[cards.labelColor]
    },
    a: {
      color: colors.secondary
    }
  };
});
exports.CardArticleLabel = CardArticleLabel;
var CardArticleContentInner = (0, _styled.default)(_rebass.Box)({
  display: 'flex',
  flexDirection: 'column'
});
exports.CardArticleContentInner = CardArticleContentInner;
var CardArticleCopy = (0, _styled.default)(_rebass.Box)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      fonts = _ref2$theme.fonts,
      colors = _ref2$theme.colors;
  return {
    fontFamily: fonts.body,
    marginTop: space.small,
    color: colors.offblack,
    p: {
      marginBottom: 0
    }
  };
});
exports.CardArticleCopy = CardArticleCopy;
var CardArticleTag = (0, _styled.default)(_Typography.Body)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      space = _ref3$theme.space;
  return {
    marginBottom: space.xsmall,
    color: colors.offblack,
    fontWeight: 'bold'
  };
});
exports.CardArticleTag = CardArticleTag;

var TagsWrapper = _styled.default.div(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      space = _ref4$theme.space,
      colors = _ref4$theme.colors;
  return {
    display: 'flex',
    flexDirection: 'row',
    borderTop: "1px solid ".concat(colors.greymid),
    marginTop: 'auto',
    paddingTop: space.small,
    color: colors.offblack
  };
});

exports.TagsWrapper = TagsWrapper;

var TagsLabel = _styled.default.div(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      fonts = _ref5$theme.fonts,
      space = _ref5$theme.space;
  return {
    fontFamily: fonts.bold,
    marginRight: space.xsmall
  };
});

exports.TagsLabel = TagsLabel;
var _default = CardArticleLabel;
exports.default = _default;